module.exports = __webpack_public_path__ + "img/how-it-works-4.9c059493.svg";